import Api from './Api';

const END_POINT = 'accounts';

export default {
    get_all(filters = null) {
        let request = {
            params: filters
        }
        return Api.get(`${END_POINT}`, request)
    },
    get_all_card_transfer() {
        return Api.get(`/get_all_card_transfer`);
    },
    
    store(account) {
        return Api.post(`${END_POINT}`, account);
    },
    update(account) {
        return Api.patch(`${END_POINT}/${account.id}`, account);
    },
    change_status(account) {
        return Api.patch(`${END_POINT}/${account.id}/change-status`, account);
    },
    delete(account) {
        return Api.delete(`${END_POINT}/${account.id}`, account);
    },
    storeMovement(movement) {
        return Api.post(`${END_POINT}/movements`, movement);
    },
    deleteMovement(movement) {
        console.log(movement.motivo);
        return Api.post(`${END_POINT}/movements/${movement.movement.id}/delete`,{motivo: movement.motivo} );
    },
    get_movements(account) {
        return Api.get(`${END_POINT}/${account.id}/movements`);
    },
}